import React from "react";

import "./BannerUbicacion.css";

const BannerUbicacion = () => {
    return (
        <>
            
            <div className="banner-ubicacion">
               
                <h1>¿Querés visitarnos?</h1>
                <h2>Nos encontramos en Córdoba, Argentina.</h2>
                <a
                    href="https://maps.app.goo.gl/GkZN29pu5y3tk7LP7"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-ubicacion"
                >
                    Conocé nuestra ubicación
                </a>
              
            </div>
        </>
    );
};

export default BannerUbicacion;
